<div class="d-flex justify-content-between modal-header border-0 p-0">
  <div>
    <h2 class="modal-title fw-bold">{{ 'COMPONENT.ASSIGN_PATIENT_TO_TIMELINE_MODAL.TITLE' | translate }}</h2>
  </div>
</div>

<div class="modal-body pb-0">
  <form [formGroup]="form" (ngSubmit)="submit()" class="validation-after-submit validation-after-touch">
    <div formArrayName="patients">
      @for (patient of patientsControl.controls; track patient; let i = $index) {
        <div class="mb-5" [formGroupName]="i">
          <div class="row">
            <div class="col-md-3 col-12">
              <h3 class="patient-name mt-4">{{patient.value.fullName}}</h3>
            </div>
            <div class="col-md-4 col-12">
              <ng-select formControlName="treatmentStatus" class="ng-select-sm period-selector"
                bindValue="value"
                [placeholder]="'COMMON.CHOOSE' | translate"
                [clearable]="false"
                [items]="treatmentStatusOptions">
                <ng-template ng-label-tmp let-item="item">
                  {{ item.label | translate }}
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                  {{ item.label | translate }}
                </ng-template>
              </ng-select>
            </div>
            @if (patientsControl.controls[i].value.treatmentStatus === TreatmentStatus.TREATMENT) {
              <div class="col-md-5 col-12">
                <ng-select formControlName="migratedTreatmentSessionNumber" class="ng-select-sm period-selector"
                  bindValue="value"
                  [placeholder]="'COMMON.CHOOSE' | translate"
                  [required]="patientsControl.controls[i].value.treatmentStatus === TreatmentStatus.TREATMENT"
                  [clearable]="false"
                  [items]="sessionOptions">
                  <ng-template ng-label-tmp let-item="item">
                    {{ 'COMPONENT.ASSIGN_PATIENT_TO_TIMELINE_MODAL.SESSION' | translate : {session: item.label} }}
                  </ng-template>
                  <ng-template ng-option-tmp let-item="item">
                    {{ 'COMPONENT.ASSIGN_PATIENT_TO_TIMELINE_MODAL.SESSION' | translate : {session: item.label} }}
                  </ng-template>
                </ng-select>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <button type="button" class="btn btn-link btn-link-primary p-0" (click)="skip()">
        {{ 'COMMON.SKIP' | translate }}
      </button>
      <button type="submit" class="btn btn-primary confirm-button" [disabled]="form.invalid">
        {{ 'COMMON.ASSIGN' | translate }}
      </button>
    </div>
  </form>
</div>